module.exports = __webpack_public_path__ + "AvertaStd-Light.svg?46dd7d75a129d571efb0c6e9d757525d";